import { styled } from '@mui/material/styles';
import { Button, Typography } from '@mui/material';

export const InputButton = styled(Button)(() => ({
  width: '57.41px',
  height: '26.2px',
  borderRadius: '4.06px',
  display: 'flex',
  justifyContent: 'center',
  alignContent: 'center',
  alignItems: 'center',
  border: '0.61px solid #E8E8E8',
  background: 'white',
  color: 'black',
}));

export const InputLine = styled('hr')(() => ({
  margin: 'auto 0',
  width: '100%',
  height: '1px',
}));

export const VerticalLine = styled('hr')(() => ({
  margin: 'auto 0',
  width: '1px',
  height: '120px',
  color: '#E8E8E8',
  background: '#E8E8E8',
}));

export const InputTextNote = styled(Typography)(() => ({
  fontWeight: 400,
  fontSize: '8.17px',
  lineHeight: '9.96px',
  fontStyle: 'italic',
}));

export const MoreText = styled(Typography)(() => ({
  color: '#E81C0E',
  fontSize: '10px',
  lineHeight: '13.35px',
  fontWeight: 600,

  whiteSpace: 'nowrap',
  marginTop: '4px',
  cursor: 'pointer',
}));

export const MoreOrLessText = styled(Typography)(() => ({
  color: '#E81C0E',
  fontSize: '10px',
  lineHeight: '13.35px',
  fontWeight: 600,
  whiteSpace: 'nowrap',
  marginTop: '4px',
  cursor: 'pointer',
}));
